module.exports = __webpack_public_path__ + "img/img2.acbf2ecc.jpg";